import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthGuard } from './components/auth/auth-guard';
import { MainLayout } from './components/layout/main-layout';
import { LandingPage } from './pages/landing-page';
import { HomePage } from './pages/home-page';
import { EditorPage } from './pages/editor-page';
import { ProjectsPage } from './pages/projects-page';
import { LoginPage } from './pages/login-page';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route element={<AuthGuard />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/projects" element={<ProjectsPage />} />
            </Route>
            <Route path="/editor/:id" element={<EditorPage />} />
            <Route path="/editor/pattern/:slug" element={<EditorPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
